import { useReveal } from "@/hooks/useReveal";

const ITEMS = [
  {
    quote: "«Очень удобно смотреть новые коллекции, не выходя из дома.»",
    name: "Алия К.",
    role: "Алматы",
  },
  {
    quote: "«ИИ-примерка приятно удивила. Помогла определиться с моделью ещё до визита.»",
    name: "Динара С.",
    role: "Астана",
  },
  {
    quote: "«Получила бонусы сразу после регистрации и использовала их при покупке.»",
    name: "Мадина Т.",
    role: "Алматы",
  },
];

export const Testimonials = () => {
  const ref = useReveal();
  return (
    <section id="testimonials" ref={ref} data-testid="testimonials-section" className="py-28 md:py-36" style={{ background: "var(--paper-2)" }}>
      <div className="pw-container">
        <span className="pw-eyebrow reveal">Отзывы</span>
        <h2 className="pw-h2 reveal mt-6 max-w-2xl mb-16">
          Наши клиенты уже используют приложение.
        </h2>
        <div className="grid md:grid-cols-3 gap-5">
          {ITEMS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-card-${i}`}
              className="reveal p-9 md:p-10 rounded-2xl bg-white border"
              style={{ borderColor: "var(--grey-3)", transitionDelay: `${i * 80}ms` }}
            >
              <blockquote className="text-lg md:text-xl font-medium leading-snug" style={{ letterSpacing: "-0.02em" }}>
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-3">
                <div
                  className="w-10 h-10 rounded-full flex items-center justify-center text-white text-[13px] font-semibold"
                  style={{ background: "var(--ink-2)" }}
                >
                  {t.name[0]}
                </div>
                <div>
                  <div className="text-[14px] font-semibold">{t.name}</div>
                  <div className="text-[12px]" style={{ color: "var(--grey-2)" }}>{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
